import React from 'react';
import {
  FiChevronRight,
  FiChevronLeft,
} from 'react-icons/fi';
import { conformToMask } from 'react-text-mask';
import { Image, standards } from '../../../../components';
import logo from '../../../../../support/assets/images/logo_fundo_branco.png';
import DonationSelector from './DonationSelector';

export default function Contribution(props) {
  const { sharedStates, remoteStates, commands } = props;
  
  return (
    <div style={{
      width: '99%',
      flexDirection: 'column',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginLeft: 20,
      marginRight: 20,
      borderStyle: 'solid',
      borderColor: standards.colors.orange.medium,
      borderWidth: 2,
      borderRadius: 15,
      paddingTop: 47,
    }}
    >
      <p style={{
        textAlign: 'center', fontSize: 16, color: '#555555', fontFamily: 'MontSerrat', padding: 20,
      }}
      >
        Você está utilizando uma plataforma
        {' '}
        <span style={{ fontWeight: 600 }}>gratuita</span>
        ,
        {' '}
        <span style={{ fontWeight: 600 }}>segura</span>
        {' '}
        e
        {' '}
        <span style={{ fontWeight: 600 }}>plural</span>
        {' '}
        desenvolvida pela comunidade da
        {' '}
        <span style={{ fontWeight: 600, color: standards.colors.orange.medium }}>Locall</span>
        .
        Doe um valor para a comunidade e ajude a alavancar este ideal!
        {/* {' '}
        <span style={{ fontWeight: 800, color: standards.colors.orange.medium }}>Saiba mais</span> 
        .*/}
      </p>

      <DonationSelector commands={commands} sharedStates={sharedStates}/>
    </div>
  );
}
